import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-to-complete',
    templateUrl: './to-complete.component.svg',
    styleUrls: ['./to-complete.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToCompleteComponent {}
